import { render } from "./ProfileEditContacts.vue?vue&type=template&id=2f9c60dc&scoped=true&ts=true"
import script from "./ProfileEditContacts.vue?vue&type=script&lang=ts"
export * from "./ProfileEditContacts.vue?vue&type=script&lang=ts"

import "./ProfileEditContacts.vue?vue&type=style&index=0&id=2f9c60dc&scoped=true&lang=css"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9c60dc"]])

export default __exports__